<template>
  <div>
    <HeroBanner />
    <CaseTypes />
    <ProcessSteps />
    <WhyChooseUs />
    <TypesOfCases />
    <Testimonials />
    <Faq />
    <CtaSection />
  </div>
</template>

<script>
import CtaSection from '@/components/Services/SectionEight/CtaSection.vue';
import TypesOfCases from '@/components/Services/SectionFive/TypesOfCases.vue';
import WhyChooseUs from '@/components/Services/SectionFour/WhyChooseUs.vue';
import HeroBanner from '@/components/Services/SectionOne/HeroBanner.vue';
import Faq from '@/components/Services/SectionSeven/Faq.vue';
import Testimonials from '@/components/Services/SectionSix/Testimonials.vue';
import ProcessSteps from '@/components/Services/SectionThree/ProcessSteps.vue';
import CaseTypes from '@/components/Services/SectionTwo/CaseTypes.vue';

export default {
  name: 'Services',
  components: {
    HeroBanner,
    CaseTypes,
    ProcessSteps,
    WhyChooseUs,
    TypesOfCases,
    Testimonials,
    Faq,
    CtaSection
  }
}
</script>

<style></style>